/** The steps before a report was sent (SA-1305), oldest first; a failed request or an error reads in the destructive tone. */
import { AlertCircle } from 'lucide-react'
import type { TimelineLine } from './feedbackAdminModel'
import * as T from './feedbackAdminText'

export function FeedbackTimeline({ lines }: { lines: TimelineLine[] }) {
  if (lines.length === 0) return <p className="text-sm text-muted-foreground">{T.NO_TIMELINE}</p>
  return (
    <ol className="space-y-1.5" data-testid="feedback-timeline">
      {lines.map((l) => (
        <li key={l.key} data-tone={l.tone}
          className={l.tone === 'error'
            ? 'flex gap-2 rounded-md bg-destructive/10 px-2 py-1 text-sm text-destructive'
            : 'flex gap-2 px-2 py-1 text-sm text-foreground'}>
          <span className="w-20 shrink-0 text-xs leading-5 text-muted-foreground">{l.before ?? ''}</span>
          <span className="min-w-0 flex-1 [overflow-wrap:anywhere]">
            {l.tone === 'error' && <AlertCircle aria-hidden="true" className="mr-1 inline size-3.5 align-[-2px]" />}
            {l.text}
            {l.detail && <span className="block text-xs text-muted-foreground">{l.detail}</span>}
          </span>
        </li>
      ))}
    </ol>
  )
}
